import { NgIf, UpperCasePipe } from '@angular/common';
import { Component, ViewChild, ViewContainerRef } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterLink } from '@angular/router';
import { FieldWrapper, FormlyModule } from '@ngx-formly/core';

@Component({
  selector: 'formly-wrapper-panel-protocollata',
  template: `
    <div class="flex flex-col bg-white border shadow-sm rounded-xl mb-6">
    <div class="flex flex-row justify-between bg-primary border-b rounded-t-xl py-3 px-4 md:py-4 md:px-5">
    <p class=" text-white">
    {{ props.label | uppercase }}
    </p>

    <div class="flex items-center">
    <mat-icon class="icon-size-5 white-icon" matPrefix [svgIcon]="'heroicons_solid:check-circle'"></mat-icon>
    <p class="font-semibold text-sm text-white ml-2">{{'Protocollata' | uppercase}}</p>
    </div>

    </div>
      <div class="p-4 md:p-5">
        <p class="mt-2 flex w-full p-4 justify-start">
          <ng-container #fieldComponent></ng-container>
        </p>

        <div class="flex justify-end px-3 py-2">
        <button [routerLink]="['/area-utente']" class="w-auto h-auto bg-primary text-white" mat-flat-button>
            <span>Chiudi</span>
        </button>
      </div>

      </div>


    </div>
  `,
  standalone: true,
  imports: [FormlyModule, RouterLink, MatIconModule, MatButtonModule, UpperCasePipe]
})
export class PanelProtocollata extends FieldWrapper {
}
